import React, { useEffect, useState } from "react";

function TopBarLoader(props) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined" && isClient) {
      // add style object containing keyframes to the document
      const style = document.createElement("style");
      style.innerHTML = `
          @keyframes hue {
            0% {
              -webkit-filter: hue-rotate(0deg);
            }
            50% {
              -webkit-filter: hue-rotate(720deg);
            }
            100% {
              -webkit-filter: hue-rotate(0deg);
            }
          }
          
          @keyframes bgroll {
            0% {
              background-position: 0% 50%;
            }
            10% {
              background-position: 100% 50%;
            }
            25% {
              background-position: 0% 50%;
            }
            100% {
              background-position: 100% 50%;
            }
          }
        `;
      document.head.appendChild(style);
    }
  }, [isClient]);

  if (!isClient) {
    return null;
  }

  const style = {
    position: "fixed" as const,
    top: 0,
    left: 0,
    width: "100vw",
    height: 4,
    backgroundImage: `${props.useTheme ? "linear-gradient(to right, #f44336, #ff9800, #4caf50)" : "linear-gradient(to right, var(--sidebarHeaderColor), var(--logoColor), var(--color2))"}`,
    backgroundSize: "250% 100%",
    zIndex: 9999,
    userSelect: "none" as const,
    pointerEvents: "none" as const,
    animation: `${props.useTheme ? "bgroll" : "hue"} 1s infinite ease`,
  };

  return <div style={style} />;
}

export default TopBarLoader;
